import { ActionReducerMapBuilder } from '@reduxjs/toolkit';

import { LOADING_STATUS } from 'shared/constants';

import { MapState } from '../../types';

import { getPlannedRoutes } from '../operations/getPlannedRoutes';

export const setPlannedRoutes = (builder: ActionReducerMapBuilder<MapState>) => builder
  .addCase(getPlannedRoutes.pending, (state) => {
    state.routes.plannedRoutesLoadingStatus = LOADING_STATUS.load;
  })
  .addCase(getPlannedRoutes.fulfilled, (state, { payload }) => {
    state.routes.plannedRoutesLoadingStatus = LOADING_STATUS.done;
    state.routes.planId = payload.planId;
    state.routes.plannedRoutes = payload.routes;
  })
  .addCase(getPlannedRoutes.rejected, (state) => {
    state.routes.plannedRoutesLoadingStatus = LOADING_STATUS.error;
  });
